/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Input } from "antd";
import classnames from "classnames";

const SearchBox = ({
  name,
  hasIcon = true,
  placeholder = "Search Here...",
  onChange = () => {},
}) => {
  return (
    <div className="">
      <Input
        type="search"
        id={name}
        name={name}
        // prefix={<FiSearch />}
        className={classnames(
          "h-[36px] block w-full rounded-md border-0 py-[6px] text-gray-500 shadow-sm ring-1 ring-inset  placeholder:text-gray-400 placeholder:font-light focus:ring-inset  sm:text-sm sm:leading-6 ring-gray-300 focus:ring-blue-400"
        )}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchBox;
